import styled from "styled-components";

export const StyledImg = styled.img`
  width: 17.39pt;
  height: 16.2pt;
`;
